import { store } from '../store';
import { SET_CASINO_NET_POSITION } from '../types/casinoTypes';

export const setCasinoNetPosition = (meta: number) => {
  store.dispatch({
    meta,
    type: SET_CASINO_NET_POSITION,
  });
};
